import React from 'react';
import { Modal } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';
import UploadDocuments from '../../../Components/UploadDocuments/UploadDocuments';

function ImportModal({ showUploadModal, closeUploadModal, docRef, addDocument, loader }) {
  const { t } = useTranslation('common');

  return (
    <Modal show={showUploadModal} className="custom-modal modal-medium-2x color-way-modal" aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <Modal.Title id="contained-modal-title-vcenter">{t('CARE_LABELS.IMPORT_MODAL.UPLOAD_FILE')}</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <UploadDocuments setShowGradingGroupError={() => {}} hideName ref={docRef} accept=".xlsx, .xls" />

        <div className="modal-buttons mt-4 d-flex justify-content-between">
          <button className="btn btn-default" type="button" onClick={closeUploadModal}>
            {t('CARE_LABELS.IMPORT_MODAL.CANCEL')}
          </button>
          <button onClick={addDocument} type="button" className="btn btn-default" disabled={loader}>
            {loader ? <Spinner animation="border" /> : t('CARE_LABELS.IMPORT_MODAL.ADD')}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ImportModal;
